module.exports = __webpack_public_path__ + "static/media/mingma_foundation_new_logo.e59c09dc.png";